import React, { useContext } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./Utils/ScrollToTop";
import CookieBanner from "./Utils/CookieBanner";
import { Helmet } from "react-helmet";
import { ThemeContext } from "../App";

const Layout = ({ children, auth, isLoading, networkErr }) => {
  const themeConfig = useContext(ThemeContext);
  const currentTheme = process.env.REACT_APP_THEME;

  const setFont = () => {
    if (currentTheme === "helmsmarthome") return "Rubik";
    if (currentTheme === "homelink") return '"Montserrat", sans-serif';
  };

  const baseFont = { fontFamily: setFont() };

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="initial-scale = 1.0,maximum-scale = 1.0,user-scalable=no,width=device-width"
        />
        <meta name="description" content="Smart Security for Your Home" />
        <title>{themeConfig.title}</title>
        <link rel="shortcut icon" href={themeConfig.favicon} />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        {currentTheme === "helmsmarthome" ? (
          <link
            href="https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800;900&display=swap"
            rel="stylesheet"
          />
        ) : currentTheme === "homelink" ? (
          <link
            href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700;800&display=swap"
            rel="stylesheet"
          />
        ) : (
          ""
        )}
        <link
          rel="stylesheet"
          href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
          integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p"
          crossOrigin="anonymous"
        />
      </Helmet>
      <Navbar auth={auth} baseFont={baseFont} />
      <div style={baseFont}>{children}</div>
      <ScrollToTop />
      <Footer
        auth={auth}
        isLoading={isLoading}
        networkErr={networkErr}
        baseFont={baseFont}
      />
      {process.env.REACT_APP_THEME === "brightsuite" && <CookieBanner />}
    </>
  );
};

export default Layout;
